/* eslint-disable */
import {
  Anchor,
  Category,
  Color,
  Image,
  Paragraph,
  ProductMeta,
  ProductSaleState,
  productSaleStateFromJSON,
  productSaleStateToJSON,
  Promotion,
  Rating,
} from "../common/common";

export const protobufPackage = "store.api.store";

/** GetProductRequest defines the request of GetProduct api. */
export interface GetProductRequest {
  /** product id or sku id (truncate to 5 characters and treat it as product id) */
  productId: string;
  /** Required. Determine whether the given `id` is for preview. */
  preview: boolean;
}

/** empty for now */
export interface ListOutfitStylesRequest {
}

export interface ListOutfitStylesResponse {
  styles: OutfitStyle[];
  /** Key is product id and value is the product meta. */
  metas: { [key: string]: ProductMeta };
}

export interface ListOutfitStylesResponse_MetasEntry {
  key: string;
  value: ProductMeta | undefined;
}

/** empty for now */
export interface ListOutfitStylesV2Request {
}

export interface ListOutfitStylesV2Response {
  styles: OutfitStyle[];
}

export interface GetOutfitStyleRequest {
  /** Required. outfit style id */
  id: string;
  /** Optional. 模式 */
  mode: GetOutfitStyleRequest_Mode;
}

export enum GetOutfitStyleRequest_Mode {
  /** MODE_UNSPECIFIED - return all */
  MODE_UNSPECIFIED = 0,
  /** MODE_META - only return `OutfitStyle`.`id`, `OutfitStyle`.`title`, `OutfitStyle`.`cover`, `OutfitStyle`.`item_aspect_ratio`, `OutfitStyle`.`items` => `image_hash` */
  MODE_META = 1,
}

export function getOutfitStyleRequest_ModeFromJSON(object: any): GetOutfitStyleRequest_Mode {
  switch (object) {
    case 0:
    case "MODE_UNSPECIFIED":
      return GetOutfitStyleRequest_Mode.MODE_UNSPECIFIED;
    case 1:
    case "MODE_META":
      return GetOutfitStyleRequest_Mode.MODE_META;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum GetOutfitStyleRequest_Mode");
  }
}

export function getOutfitStyleRequest_ModeToJSON(object: GetOutfitStyleRequest_Mode): string {
  switch (object) {
    case GetOutfitStyleRequest_Mode.MODE_UNSPECIFIED:
      return "MODE_UNSPECIFIED";
    case GetOutfitStyleRequest_Mode.MODE_META:
      return "MODE_META";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum GetOutfitStyleRequest_Mode");
  }
}

export interface GetOutfitStyleResponse {
  style:
    | OutfitStyle
    | undefined;
  /** Key is product id and value is the product meta. */
  metas: { [key: string]: ProductMeta };
}

export interface GetOutfitStyleResponse_MetasEntry {
  key: string;
  value: ProductMeta | undefined;
}

/** Product defines the data for product detail page. */
export interface Product {
  /** product meta */
  meta:
    | ProductMeta
    | undefined;
  /** common images. 穿搭圖A. */
  outfitImages: Product_ProductImage[];
  /** promotion */
  promotion:
    | Promotion
    | undefined;
  /** colors of the product */
  colors: Product_SkuColor[];
  /** sizes of the product */
  sizes: Product_SkuSize[];
  /** latest rating of the product */
  rating:
    | Rating
    | undefined;
  /** total rating count of the product */
  ratingCount: number;
  /** produce origin of the product */
  origin: string;
  /** frontend material of the product */
  material: string;
  /** product precaution and notices */
  productInfo:
    | Paragraph
    | undefined;
  /** size chart hint */
  sizeChartHints: string[];
  /** common images. 說明圖D. */
  commonImages: Product_ProductImage[];
  /** 尺碼表圖片. */
  sizeChartImage:
    | Image
    | undefined;
  /** 試穿報告圖片. */
  fittingReportImage:
    | Image
    | undefined;
  /** 尺寸測量圖1. */
  firstSizeMeasurementImage:
    | Image
    | undefined;
  /** 尺寸測量圖2. */
  secondSizeMeasurementImage:
    | Image
    | undefined;
  /** shipping fee and fee promotion */
  shippingFee:
    | Product_ShippingFee
    | undefined;
  /** key is sku id value is inventory */
  inventory: { [key: string]: Product_Inventory };
  /** is the product published */
  published: boolean;
  /** share image url */
  shareImage: string;
  /** true 試穿尺寸對照表. false 真人試穿紀錄 */
  isBabyFitting: boolean;
  /** medium category */
  medium:
    | Category
    | undefined;
  /** small category */
  small:
    | Category
    | undefined;
  /** analytics tag for the product */
  tags: string[];
}

/** SkuColor defines a color of the product. */
export interface Product_SkuColor {
  /** the 6th and 7th digits of sku id. */
  id: string;
  /** color content. */
  color:
    | Color
    | undefined;
  /** hash of 平拍. */
  image:
    | Product_ImageSet
    | undefined;
  /** hash of 延伸款. */
  extImage: Product_ImageSet | undefined;
}

/** SkuSize defines a size of the product. */
export interface Product_SkuSize {
  /** the 8th digit of sku id. */
  id: string;
  /** size name */
  name: string;
  /** 尺码后缀 */
  suffix: string;
  /** 是否是延伸款 */
  isExtension: boolean;
}

/** ImageSet defines the display sets for 平拍图 */
export interface Product_ImageSet {
  /** image thumbnail. size of 220 pixel resolution. */
  img220: string;
  /** image in small size of 360 pixel resolution. */
  img360: string;
  /** image in medium size of 500 pixel resolution. */
  img500: string;
  /** image in large size of 1500 pixel resolution. */
  img1500: string;
}

/** ProductImage defines the image with related products. */
export interface Product_ProductImage {
  /** product image */
  image:
    | Image
    | undefined;
  /** related products with anchors for the product */
  anchorProducts: Product_ProductImage_AnchorProduct[];
}

export interface Product_ProductImage_AnchorProduct {
  /** product meta */
  meta:
    | ProductMeta
    | undefined;
  /** anchor of the product */
  anchor:
    | Anchor
    | undefined;
  /** colors of the product */
  colors: Product_SkuColor[];
  /** sizes of the product */
  sizes: Product_SkuSize[];
  /** size chart hint */
  sizeChartHints: string[];
  /** Output only. 尺碼表圖片. */
  sizeChartImage:
    | Image
    | undefined;
  /** Output only. 試穿報告圖片. */
  fittingReportImage:
    | Image
    | undefined;
  /** Output only. 尺寸測量圖1. */
  firstSizeMeasurementImage:
    | Image
    | undefined;
  /** Output only. 尺寸測量圖2. */
  secondSizeMeasurementImage:
    | Image
    | undefined;
  /** key is sku id value is inventory */
  inventory: { [key: string]: Product_Inventory };
  /** product precaution and notices */
  productInfo:
    | Paragraph
    | undefined;
  /** promotion */
  promotion:
    | Promotion
    | undefined;
  /** product sale state */
  saleState: ProductSaleState;
  /** tag name */
  tagName: string;
  /** true 試穿尺寸對照表. false 真人試穿紀錄 */
  isBabyFitting: boolean;
}

export interface Product_ProductImage_AnchorProduct_InventoryEntry {
  key: string;
  value: Product_Inventory | undefined;
}

/** Inventory defines the inventory count and if it has stock reminder */
export interface Product_Inventory {
  num: number;
  stockRemind: boolean;
}

export interface Product_ShippingFee {
  /** 付款 */
  paymentTitle: string;
  /** 運費活動 */
  promotionTitle: string;
  /** 配送標題 */
  deliveryTitle: string;
  /** 配送內文 */
  deliveryContent: string;
  /** 付款與運送方式 */
  feeInfos: Product_ShippingFee_FeeInfo[];
}

export interface Product_ShippingFee_FeeInfo {
  /** 付款方式 */
  desc?:
    | string
    | undefined;
  /** 付款圖示 */
  image?:
    | Image
    | undefined;
  /** 免運條件 */
  subTitle: string;
  /** 運費金額 */
  fee: string;
}

export interface Product_InventoryEntry {
  key: string;
  value: Product_Inventory | undefined;
}

/** OutfitStyleV2 defines the data for outfit style. */
export interface OutfitStyle {
  /** outfit style id */
  id: string;
  /** outfit style title */
  title: string;
  /** outfit style cover */
  cover:
    | Image
    | undefined;
  /** outfit style items */
  items: OutfitStyle_Item[];
  /** aspect ratio of items image image */
  itemAspectRatio: number;
}

/** Item defines the data for outfit style item. */
export interface OutfitStyle_Item {
  /** outfit style item image */
  imageHash: string;
  /** related product ids */
  anchorProducts: OutfitStyle_Item_AnchorProduct[];
}

/** AnchorProduct defines the data for outfit style item's anchor product. */
export interface OutfitStyle_Item_AnchorProduct {
  /** product id */
  productId: string;
  /** anchor products with anchors for the product */
  anchor:
    | Anchor
    | undefined;
  /** product sale state */
  saleState: ProductSaleState;
  /** tag name */
  tagName: string;
}

function createBaseGetProductRequest(): GetProductRequest {
  return { productId: "", preview: false };
}

export const GetProductRequest = {
  fromJSON(object: any): GetProductRequest {
    return {
      productId: isSet(object.productId) ? String(object.productId) : "",
      preview: isSet(object.preview) ? Boolean(object.preview) : false,
    };
  },

  toJSON(message: GetProductRequest): unknown {
    const obj: any = {};
    message.productId !== undefined && (obj.productId = message.productId);
    message.preview !== undefined && (obj.preview = message.preview);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetProductRequest>, I>>(base?: I): GetProductRequest {
    return GetProductRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetProductRequest>, I>>(object: I): GetProductRequest {
    const message = createBaseGetProductRequest();
    message.productId = object.productId ?? "";
    message.preview = object.preview ?? false;
    return message;
  },
};

function createBaseListOutfitStylesRequest(): ListOutfitStylesRequest {
  return {};
}

export const ListOutfitStylesRequest = {
  fromJSON(_: any): ListOutfitStylesRequest {
    return {};
  },

  toJSON(_: ListOutfitStylesRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOutfitStylesRequest>, I>>(base?: I): ListOutfitStylesRequest {
    return ListOutfitStylesRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOutfitStylesRequest>, I>>(_: I): ListOutfitStylesRequest {
    const message = createBaseListOutfitStylesRequest();
    return message;
  },
};

function createBaseListOutfitStylesResponse(): ListOutfitStylesResponse {
  return { styles: [], metas: {} };
}

export const ListOutfitStylesResponse = {
  fromJSON(object: any): ListOutfitStylesResponse {
    return {
      styles: Array.isArray(object?.styles) ? object.styles.map((e: any) => OutfitStyle.fromJSON(e)) : [],
      metas: isObject(object.metas)
        ? Object.entries(object.metas).reduce<{ [key: string]: ProductMeta }>((acc, [key, value]) => {
          acc[key] = ProductMeta.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: ListOutfitStylesResponse): unknown {
    const obj: any = {};
    if (message.styles) {
      obj.styles = message.styles.map((e) => e ? OutfitStyle.toJSON(e) : undefined);
    } else {
      obj.styles = [];
    }
    obj.metas = {};
    if (message.metas) {
      Object.entries(message.metas).forEach(([k, v]) => {
        obj.metas[k] = ProductMeta.toJSON(v);
      });
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOutfitStylesResponse>, I>>(base?: I): ListOutfitStylesResponse {
    return ListOutfitStylesResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOutfitStylesResponse>, I>>(object: I): ListOutfitStylesResponse {
    const message = createBaseListOutfitStylesResponse();
    message.styles = object.styles?.map((e) => OutfitStyle.fromPartial(e)) || [];
    message.metas = Object.entries(object.metas ?? {}).reduce<{ [key: string]: ProductMeta }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = ProductMeta.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseListOutfitStylesResponse_MetasEntry(): ListOutfitStylesResponse_MetasEntry {
  return { key: "", value: undefined };
}

export const ListOutfitStylesResponse_MetasEntry = {
  fromJSON(object: any): ListOutfitStylesResponse_MetasEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? ProductMeta.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListOutfitStylesResponse_MetasEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? ProductMeta.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOutfitStylesResponse_MetasEntry>, I>>(
    base?: I,
  ): ListOutfitStylesResponse_MetasEntry {
    return ListOutfitStylesResponse_MetasEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOutfitStylesResponse_MetasEntry>, I>>(
    object: I,
  ): ListOutfitStylesResponse_MetasEntry {
    const message = createBaseListOutfitStylesResponse_MetasEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ProductMeta.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseListOutfitStylesV2Request(): ListOutfitStylesV2Request {
  return {};
}

export const ListOutfitStylesV2Request = {
  fromJSON(_: any): ListOutfitStylesV2Request {
    return {};
  },

  toJSON(_: ListOutfitStylesV2Request): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOutfitStylesV2Request>, I>>(base?: I): ListOutfitStylesV2Request {
    return ListOutfitStylesV2Request.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOutfitStylesV2Request>, I>>(_: I): ListOutfitStylesV2Request {
    const message = createBaseListOutfitStylesV2Request();
    return message;
  },
};

function createBaseListOutfitStylesV2Response(): ListOutfitStylesV2Response {
  return { styles: [] };
}

export const ListOutfitStylesV2Response = {
  fromJSON(object: any): ListOutfitStylesV2Response {
    return { styles: Array.isArray(object?.styles) ? object.styles.map((e: any) => OutfitStyle.fromJSON(e)) : [] };
  },

  toJSON(message: ListOutfitStylesV2Response): unknown {
    const obj: any = {};
    if (message.styles) {
      obj.styles = message.styles.map((e) => e ? OutfitStyle.toJSON(e) : undefined);
    } else {
      obj.styles = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOutfitStylesV2Response>, I>>(base?: I): ListOutfitStylesV2Response {
    return ListOutfitStylesV2Response.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOutfitStylesV2Response>, I>>(object: I): ListOutfitStylesV2Response {
    const message = createBaseListOutfitStylesV2Response();
    message.styles = object.styles?.map((e) => OutfitStyle.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOutfitStyleRequest(): GetOutfitStyleRequest {
  return { id: "", mode: 0 };
}

export const GetOutfitStyleRequest = {
  fromJSON(object: any): GetOutfitStyleRequest {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      mode: isSet(object.mode) ? getOutfitStyleRequest_ModeFromJSON(object.mode) : 0,
    };
  },

  toJSON(message: GetOutfitStyleRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.mode !== undefined && (obj.mode = getOutfitStyleRequest_ModeToJSON(message.mode));
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOutfitStyleRequest>, I>>(base?: I): GetOutfitStyleRequest {
    return GetOutfitStyleRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOutfitStyleRequest>, I>>(object: I): GetOutfitStyleRequest {
    const message = createBaseGetOutfitStyleRequest();
    message.id = object.id ?? "";
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseGetOutfitStyleResponse(): GetOutfitStyleResponse {
  return { style: undefined, metas: {} };
}

export const GetOutfitStyleResponse = {
  fromJSON(object: any): GetOutfitStyleResponse {
    return {
      style: isSet(object.style) ? OutfitStyle.fromJSON(object.style) : undefined,
      metas: isObject(object.metas)
        ? Object.entries(object.metas).reduce<{ [key: string]: ProductMeta }>((acc, [key, value]) => {
          acc[key] = ProductMeta.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: GetOutfitStyleResponse): unknown {
    const obj: any = {};
    message.style !== undefined && (obj.style = message.style ? OutfitStyle.toJSON(message.style) : undefined);
    obj.metas = {};
    if (message.metas) {
      Object.entries(message.metas).forEach(([k, v]) => {
        obj.metas[k] = ProductMeta.toJSON(v);
      });
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOutfitStyleResponse>, I>>(base?: I): GetOutfitStyleResponse {
    return GetOutfitStyleResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOutfitStyleResponse>, I>>(object: I): GetOutfitStyleResponse {
    const message = createBaseGetOutfitStyleResponse();
    message.style = (object.style !== undefined && object.style !== null)
      ? OutfitStyle.fromPartial(object.style)
      : undefined;
    message.metas = Object.entries(object.metas ?? {}).reduce<{ [key: string]: ProductMeta }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = ProductMeta.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseGetOutfitStyleResponse_MetasEntry(): GetOutfitStyleResponse_MetasEntry {
  return { key: "", value: undefined };
}

export const GetOutfitStyleResponse_MetasEntry = {
  fromJSON(object: any): GetOutfitStyleResponse_MetasEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? ProductMeta.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetOutfitStyleResponse_MetasEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? ProductMeta.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOutfitStyleResponse_MetasEntry>, I>>(
    base?: I,
  ): GetOutfitStyleResponse_MetasEntry {
    return GetOutfitStyleResponse_MetasEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOutfitStyleResponse_MetasEntry>, I>>(
    object: I,
  ): GetOutfitStyleResponse_MetasEntry {
    const message = createBaseGetOutfitStyleResponse_MetasEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ProductMeta.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseProduct(): Product {
  return {
    meta: undefined,
    outfitImages: [],
    promotion: undefined,
    colors: [],
    sizes: [],
    rating: undefined,
    ratingCount: 0,
    origin: "",
    material: "",
    productInfo: undefined,
    sizeChartHints: [],
    commonImages: [],
    sizeChartImage: undefined,
    fittingReportImage: undefined,
    firstSizeMeasurementImage: undefined,
    secondSizeMeasurementImage: undefined,
    shippingFee: undefined,
    inventory: {},
    published: false,
    shareImage: "",
    isBabyFitting: false,
    medium: undefined,
    small: undefined,
    tags: [],
  };
}

export const Product = {
  fromJSON(object: any): Product {
    return {
      meta: isSet(object.meta) ? ProductMeta.fromJSON(object.meta) : undefined,
      outfitImages: Array.isArray(object?.outfitImages)
        ? object.outfitImages.map((e: any) => Product_ProductImage.fromJSON(e))
        : [],
      promotion: isSet(object.promotion) ? Promotion.fromJSON(object.promotion) : undefined,
      colors: Array.isArray(object?.colors)
        ? object.colors.map((e: any) => Product_SkuColor.fromJSON(e))
        : [],
      sizes: Array.isArray(object?.sizes) ? object.sizes.map((e: any) => Product_SkuSize.fromJSON(e)) : [],
      rating: isSet(object.rating) ? Rating.fromJSON(object.rating) : undefined,
      ratingCount: isSet(object.ratingCount) ? Number(object.ratingCount) : 0,
      origin: isSet(object.origin) ? String(object.origin) : "",
      material: isSet(object.material) ? String(object.material) : "",
      productInfo: isSet(object.productInfo) ? Paragraph.fromJSON(object.productInfo) : undefined,
      sizeChartHints: Array.isArray(object?.sizeChartHints) ? object.sizeChartHints.map((e: any) => String(e)) : [],
      commonImages: Array.isArray(object?.commonImages)
        ? object.commonImages.map((e: any) => Product_ProductImage.fromJSON(e))
        : [],
      sizeChartImage: isSet(object.sizeChartImage) ? Image.fromJSON(object.sizeChartImage) : undefined,
      fittingReportImage: isSet(object.fittingReportImage) ? Image.fromJSON(object.fittingReportImage) : undefined,
      firstSizeMeasurementImage: isSet(object.firstSizeMeasurementImage)
        ? Image.fromJSON(object.firstSizeMeasurementImage)
        : undefined,
      secondSizeMeasurementImage: isSet(object.secondSizeMeasurementImage)
        ? Image.fromJSON(object.secondSizeMeasurementImage)
        : undefined,
      shippingFee: isSet(object.shippingFee) ? Product_ShippingFee.fromJSON(object.shippingFee) : undefined,
      inventory: isObject(object.inventory)
        ? Object.entries(object.inventory).reduce<{ [key: string]: Product_Inventory }>((acc, [key, value]) => {
          acc[key] = Product_Inventory.fromJSON(value);
          return acc;
        }, {})
        : {},
      published: isSet(object.published) ? Boolean(object.published) : false,
      shareImage: isSet(object.shareImage) ? String(object.shareImage) : "",
      isBabyFitting: isSet(object.isBabyFitting) ? Boolean(object.isBabyFitting) : false,
      medium: isSet(object.medium) ? Category.fromJSON(object.medium) : undefined,
      small: isSet(object.small) ? Category.fromJSON(object.small) : undefined,
      tags: Array.isArray(object?.tags)
        ? object.tags.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: Product): unknown {
    const obj: any = {};
    message.meta !== undefined && (obj.meta = message.meta ? ProductMeta.toJSON(message.meta) : undefined);
    if (message.outfitImages) {
      obj.outfitImages = message.outfitImages.map((e) => e ? Product_ProductImage.toJSON(e) : undefined);
    } else {
      obj.outfitImages = [];
    }
    message.promotion !== undefined &&
      (obj.promotion = message.promotion ? Promotion.toJSON(message.promotion) : undefined);
    if (message.colors) {
      obj.colors = message.colors.map((e) => e ? Product_SkuColor.toJSON(e) : undefined);
    } else {
      obj.colors = [];
    }
    if (message.sizes) {
      obj.sizes = message.sizes.map((e) => e ? Product_SkuSize.toJSON(e) : undefined);
    } else {
      obj.sizes = [];
    }
    message.rating !== undefined && (obj.rating = message.rating ? Rating.toJSON(message.rating) : undefined);
    message.ratingCount !== undefined && (obj.ratingCount = Math.round(message.ratingCount));
    message.origin !== undefined && (obj.origin = message.origin);
    message.material !== undefined && (obj.material = message.material);
    message.productInfo !== undefined &&
      (obj.productInfo = message.productInfo ? Paragraph.toJSON(message.productInfo) : undefined);
    if (message.sizeChartHints) {
      obj.sizeChartHints = message.sizeChartHints.map((e) => e);
    } else {
      obj.sizeChartHints = [];
    }
    if (message.commonImages) {
      obj.commonImages = message.commonImages.map((e) => e ? Product_ProductImage.toJSON(e) : undefined);
    } else {
      obj.commonImages = [];
    }
    message.sizeChartImage !== undefined &&
      (obj.sizeChartImage = message.sizeChartImage ? Image.toJSON(message.sizeChartImage) : undefined);
    message.fittingReportImage !== undefined &&
      (obj.fittingReportImage = message.fittingReportImage ? Image.toJSON(message.fittingReportImage) : undefined);
    message.firstSizeMeasurementImage !== undefined &&
      (obj.firstSizeMeasurementImage = message.firstSizeMeasurementImage
        ? Image.toJSON(message.firstSizeMeasurementImage)
        : undefined);
    message.secondSizeMeasurementImage !== undefined &&
      (obj.secondSizeMeasurementImage = message.secondSizeMeasurementImage
        ? Image.toJSON(message.secondSizeMeasurementImage)
        : undefined);
    message.shippingFee !== undefined &&
      (obj.shippingFee = message.shippingFee ? Product_ShippingFee.toJSON(message.shippingFee) : undefined);
    obj.inventory = {};
    if (message.inventory) {
      Object.entries(message.inventory).forEach(([k, v]) => {
        obj.inventory[k] = Product_Inventory.toJSON(v);
      });
    }
    message.published !== undefined && (obj.published = message.published);
    message.shareImage !== undefined && (obj.shareImage = message.shareImage);
    message.isBabyFitting !== undefined && (obj.isBabyFitting = message.isBabyFitting);
    message.medium !== undefined && (obj.medium = message.medium ? Category.toJSON(message.medium) : undefined);
    message.small !== undefined && (obj.small = message.small ? Category.toJSON(message.small) : undefined);
    if (message.tags) {
      obj.tags = message.tags.map((e) => e);
    } else {
      obj.tags = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Product>, I>>(base?: I): Product {
    return Product.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product>, I>>(object: I): Product {
    const message = createBaseProduct();
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? ProductMeta.fromPartial(object.meta)
      : undefined;
    message.outfitImages = object.outfitImages?.map((e) => Product_ProductImage.fromPartial(e)) || [];
    message.promotion = (object.promotion !== undefined && object.promotion !== null)
      ? Promotion.fromPartial(object.promotion)
      : undefined;
    message.colors = object.colors?.map((e) => Product_SkuColor.fromPartial(e)) || [];
    message.sizes = object.sizes?.map((e) => Product_SkuSize.fromPartial(e)) || [];
    message.rating = (object.rating !== undefined && object.rating !== null)
      ? Rating.fromPartial(object.rating)
      : undefined;
    message.ratingCount = object.ratingCount ?? 0;
    message.origin = object.origin ?? "";
    message.material = object.material ?? "";
    message.productInfo = (object.productInfo !== undefined && object.productInfo !== null)
      ? Paragraph.fromPartial(object.productInfo)
      : undefined;
    message.sizeChartHints = object.sizeChartHints?.map((e) => e) || [];
    message.commonImages = object.commonImages?.map((e) => Product_ProductImage.fromPartial(e)) || [];
    message.sizeChartImage = (object.sizeChartImage !== undefined && object.sizeChartImage !== null)
      ? Image.fromPartial(object.sizeChartImage)
      : undefined;
    message.fittingReportImage = (object.fittingReportImage !== undefined && object.fittingReportImage !== null)
      ? Image.fromPartial(object.fittingReportImage)
      : undefined;
    message.firstSizeMeasurementImage =
      (object.firstSizeMeasurementImage !== undefined && object.firstSizeMeasurementImage !== null)
        ? Image.fromPartial(object.firstSizeMeasurementImage)
        : undefined;
    message.secondSizeMeasurementImage =
      (object.secondSizeMeasurementImage !== undefined && object.secondSizeMeasurementImage !== null)
        ? Image.fromPartial(object.secondSizeMeasurementImage)
        : undefined;
    message.shippingFee = (object.shippingFee !== undefined && object.shippingFee !== null)
      ? Product_ShippingFee.fromPartial(object.shippingFee)
      : undefined;
    message.inventory = Object.entries(object.inventory ?? {}).reduce<{ [key: string]: Product_Inventory }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = Product_Inventory.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.published = object.published ?? false;
    message.shareImage = object.shareImage ?? "";
    message.isBabyFitting = object.isBabyFitting ?? false;
    message.medium = (object.medium !== undefined && object.medium !== null)
      ? Category.fromPartial(object.medium)
      : undefined;
    message.small = (object.small !== undefined && object.small !== null)
      ? Category.fromPartial(object.small)
      : undefined;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseProduct_SkuColor(): Product_SkuColor {
  return { id: "", color: undefined, image: undefined, extImage: undefined };
}

export const Product_SkuColor = {
  fromJSON(object: any): Product_SkuColor {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      color: isSet(object.color) ? Color.fromJSON(object.color) : undefined,
      image: isSet(object.image) ? Product_ImageSet.fromJSON(object.image) : undefined,
      extImage: isSet(object.extImage) ? Product_ImageSet.fromJSON(object.extImage) : undefined,
    };
  },

  toJSON(message: Product_SkuColor): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.color !== undefined && (obj.color = message.color ? Color.toJSON(message.color) : undefined);
    message.image !== undefined && (obj.image = message.image ? Product_ImageSet.toJSON(message.image) : undefined);
    message.extImage !== undefined &&
      (obj.extImage = message.extImage ? Product_ImageSet.toJSON(message.extImage) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_SkuColor>, I>>(base?: I): Product_SkuColor {
    return Product_SkuColor.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_SkuColor>, I>>(object: I): Product_SkuColor {
    const message = createBaseProduct_SkuColor();
    message.id = object.id ?? "";
    message.color = (object.color !== undefined && object.color !== null) ? Color.fromPartial(object.color) : undefined;
    message.image = (object.image !== undefined && object.image !== null)
      ? Product_ImageSet.fromPartial(object.image)
      : undefined;
    message.extImage = (object.extImage !== undefined && object.extImage !== null)
      ? Product_ImageSet.fromPartial(object.extImage)
      : undefined;
    return message;
  },
};

function createBaseProduct_SkuSize(): Product_SkuSize {
  return { id: "", name: "", suffix: "", isExtension: false };
}

export const Product_SkuSize = {
  fromJSON(object: any): Product_SkuSize {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      name: isSet(object.name) ? String(object.name) : "",
      suffix: isSet(object.suffix) ? String(object.suffix) : "",
      isExtension: isSet(object.isExtension) ? Boolean(object.isExtension) : false,
    };
  },

  toJSON(message: Product_SkuSize): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.name !== undefined && (obj.name = message.name);
    message.suffix !== undefined && (obj.suffix = message.suffix);
    message.isExtension !== undefined && (obj.isExtension = message.isExtension);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_SkuSize>, I>>(base?: I): Product_SkuSize {
    return Product_SkuSize.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_SkuSize>, I>>(object: I): Product_SkuSize {
    const message = createBaseProduct_SkuSize();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.suffix = object.suffix ?? "";
    message.isExtension = object.isExtension ?? false;
    return message;
  },
};

function createBaseProduct_ImageSet(): Product_ImageSet {
  return { img220: "", img360: "", img500: "", img1500: "" };
}

export const Product_ImageSet = {
  fromJSON(object: any): Product_ImageSet {
    return {
      img220: isSet(object.img220) ? String(object.img220) : "",
      img360: isSet(object.img360) ? String(object.img360) : "",
      img500: isSet(object.img500) ? String(object.img500) : "",
      img1500: isSet(object.img1500) ? String(object.img1500) : "",
    };
  },

  toJSON(message: Product_ImageSet): unknown {
    const obj: any = {};
    message.img220 !== undefined && (obj.img220 = message.img220);
    message.img360 !== undefined && (obj.img360 = message.img360);
    message.img500 !== undefined && (obj.img500 = message.img500);
    message.img1500 !== undefined && (obj.img1500 = message.img1500);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ImageSet>, I>>(base?: I): Product_ImageSet {
    return Product_ImageSet.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ImageSet>, I>>(object: I): Product_ImageSet {
    const message = createBaseProduct_ImageSet();
    message.img220 = object.img220 ?? "";
    message.img360 = object.img360 ?? "";
    message.img500 = object.img500 ?? "";
    message.img1500 = object.img1500 ?? "";
    return message;
  },
};

function createBaseProduct_ProductImage(): Product_ProductImage {
  return { image: undefined, anchorProducts: [] };
}

export const Product_ProductImage = {
  fromJSON(object: any): Product_ProductImage {
    return {
      image: isSet(object.image) ? Image.fromJSON(object.image) : undefined,
      anchorProducts: Array.isArray(object?.anchorProducts)
        ? object.anchorProducts.map((e: any) => Product_ProductImage_AnchorProduct.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Product_ProductImage): unknown {
    const obj: any = {};
    message.image !== undefined && (obj.image = message.image ? Image.toJSON(message.image) : undefined);
    if (message.anchorProducts) {
      obj.anchorProducts = message.anchorProducts.map((e) =>
        e ? Product_ProductImage_AnchorProduct.toJSON(e) : undefined
      );
    } else {
      obj.anchorProducts = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ProductImage>, I>>(base?: I): Product_ProductImage {
    return Product_ProductImage.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ProductImage>, I>>(object: I): Product_ProductImage {
    const message = createBaseProduct_ProductImage();
    message.image = (object.image !== undefined && object.image !== null) ? Image.fromPartial(object.image) : undefined;
    message.anchorProducts = object.anchorProducts?.map((e) => Product_ProductImage_AnchorProduct.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProduct_ProductImage_AnchorProduct(): Product_ProductImage_AnchorProduct {
  return {
    meta: undefined,
    anchor: undefined,
    colors: [],
    sizes: [],
    sizeChartHints: [],
    sizeChartImage: undefined,
    fittingReportImage: undefined,
    firstSizeMeasurementImage: undefined,
    secondSizeMeasurementImage: undefined,
    inventory: {},
    productInfo: undefined,
    promotion: undefined,
    saleState: 0,
    tagName: "",
    isBabyFitting: false,
  };
}

export const Product_ProductImage_AnchorProduct = {
  fromJSON(object: any): Product_ProductImage_AnchorProduct {
    return {
      meta: isSet(object.meta) ? ProductMeta.fromJSON(object.meta) : undefined,
      anchor: isSet(object.anchor) ? Anchor.fromJSON(object.anchor) : undefined,
      colors: Array.isArray(object?.colors) ? object.colors.map((e: any) => Product_SkuColor.fromJSON(e)) : [],
      sizes: Array.isArray(object?.sizes) ? object.sizes.map((e: any) => Product_SkuSize.fromJSON(e)) : [],
      sizeChartHints: Array.isArray(object?.sizeChartHints) ? object.sizeChartHints.map((e: any) => String(e)) : [],
      sizeChartImage: isSet(object.sizeChartImage) ? Image.fromJSON(object.sizeChartImage) : undefined,
      fittingReportImage: isSet(object.fittingReportImage) ? Image.fromJSON(object.fittingReportImage) : undefined,
      firstSizeMeasurementImage: isSet(object.firstSizeMeasurementImage)
        ? Image.fromJSON(object.firstSizeMeasurementImage)
        : undefined,
      secondSizeMeasurementImage: isSet(object.secondSizeMeasurementImage)
        ? Image.fromJSON(object.secondSizeMeasurementImage)
        : undefined,
      inventory: isObject(object.inventory)
        ? Object.entries(object.inventory).reduce<{ [key: string]: Product_Inventory }>((acc, [key, value]) => {
          acc[key] = Product_Inventory.fromJSON(value);
          return acc;
        }, {})
        : {},
      productInfo: isSet(object.productInfo) ? Paragraph.fromJSON(object.productInfo) : undefined,
      promotion: isSet(object.promotion) ? Promotion.fromJSON(object.promotion) : undefined,
      saleState: isSet(object.saleState) ? productSaleStateFromJSON(object.saleState) : 0,
      tagName: isSet(object.tagName) ? String(object.tagName) : "",
      isBabyFitting: isSet(object.isBabyFitting) ? Boolean(object.isBabyFitting) : false,
    };
  },

  toJSON(message: Product_ProductImage_AnchorProduct): unknown {
    const obj: any = {};
    message.meta !== undefined && (obj.meta = message.meta ? ProductMeta.toJSON(message.meta) : undefined);
    message.anchor !== undefined && (obj.anchor = message.anchor ? Anchor.toJSON(message.anchor) : undefined);
    if (message.colors) {
      obj.colors = message.colors.map((e) => e ? Product_SkuColor.toJSON(e) : undefined);
    } else {
      obj.colors = [];
    }
    if (message.sizes) {
      obj.sizes = message.sizes.map((e) => e ? Product_SkuSize.toJSON(e) : undefined);
    } else {
      obj.sizes = [];
    }
    if (message.sizeChartHints) {
      obj.sizeChartHints = message.sizeChartHints.map((e) => e);
    } else {
      obj.sizeChartHints = [];
    }
    message.sizeChartImage !== undefined &&
      (obj.sizeChartImage = message.sizeChartImage ? Image.toJSON(message.sizeChartImage) : undefined);
    message.fittingReportImage !== undefined &&
      (obj.fittingReportImage = message.fittingReportImage ? Image.toJSON(message.fittingReportImage) : undefined);
    message.firstSizeMeasurementImage !== undefined &&
      (obj.firstSizeMeasurementImage = message.firstSizeMeasurementImage
        ? Image.toJSON(message.firstSizeMeasurementImage)
        : undefined);
    message.secondSizeMeasurementImage !== undefined &&
      (obj.secondSizeMeasurementImage = message.secondSizeMeasurementImage
        ? Image.toJSON(message.secondSizeMeasurementImage)
        : undefined);
    obj.inventory = {};
    if (message.inventory) {
      Object.entries(message.inventory).forEach(([k, v]) => {
        obj.inventory[k] = Product_Inventory.toJSON(v);
      });
    }
    message.productInfo !== undefined &&
      (obj.productInfo = message.productInfo ? Paragraph.toJSON(message.productInfo) : undefined);
    message.promotion !== undefined &&
      (obj.promotion = message.promotion ? Promotion.toJSON(message.promotion) : undefined);
    message.saleState !== undefined && (obj.saleState = productSaleStateToJSON(message.saleState));
    message.tagName !== undefined && (obj.tagName = message.tagName);
    message.isBabyFitting !== undefined && (obj.isBabyFitting = message.isBabyFitting);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ProductImage_AnchorProduct>, I>>(
    base?: I,
  ): Product_ProductImage_AnchorProduct {
    return Product_ProductImage_AnchorProduct.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ProductImage_AnchorProduct>, I>>(
    object: I,
  ): Product_ProductImage_AnchorProduct {
    const message = createBaseProduct_ProductImage_AnchorProduct();
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? ProductMeta.fromPartial(object.meta)
      : undefined;
    message.anchor = (object.anchor !== undefined && object.anchor !== null)
      ? Anchor.fromPartial(object.anchor)
      : undefined;
    message.colors = object.colors?.map((e) => Product_SkuColor.fromPartial(e)) || [];
    message.sizes = object.sizes?.map((e) => Product_SkuSize.fromPartial(e)) || [];
    message.sizeChartHints = object.sizeChartHints?.map((e) => e) || [];
    message.sizeChartImage = (object.sizeChartImage !== undefined && object.sizeChartImage !== null)
      ? Image.fromPartial(object.sizeChartImage)
      : undefined;
    message.fittingReportImage = (object.fittingReportImage !== undefined && object.fittingReportImage !== null)
      ? Image.fromPartial(object.fittingReportImage)
      : undefined;
    message.firstSizeMeasurementImage =
      (object.firstSizeMeasurementImage !== undefined && object.firstSizeMeasurementImage !== null)
        ? Image.fromPartial(object.firstSizeMeasurementImage)
        : undefined;
    message.secondSizeMeasurementImage =
      (object.secondSizeMeasurementImage !== undefined && object.secondSizeMeasurementImage !== null)
        ? Image.fromPartial(object.secondSizeMeasurementImage)
        : undefined;
    message.inventory = Object.entries(object.inventory ?? {}).reduce<{ [key: string]: Product_Inventory }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = Product_Inventory.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.productInfo = (object.productInfo !== undefined && object.productInfo !== null)
      ? Paragraph.fromPartial(object.productInfo)
      : undefined;
    message.promotion = (object.promotion !== undefined && object.promotion !== null)
      ? Promotion.fromPartial(object.promotion)
      : undefined;
    message.saleState = object.saleState ?? 0;
    message.tagName = object.tagName ?? "";
    message.isBabyFitting = object.isBabyFitting ?? false;
    return message;
  },
};

function createBaseProduct_ProductImage_AnchorProduct_InventoryEntry(): Product_ProductImage_AnchorProduct_InventoryEntry {
  return { key: "", value: undefined };
}

export const Product_ProductImage_AnchorProduct_InventoryEntry = {
  fromJSON(object: any): Product_ProductImage_AnchorProduct_InventoryEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Product_Inventory.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: Product_ProductImage_AnchorProduct_InventoryEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? Product_Inventory.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ProductImage_AnchorProduct_InventoryEntry>, I>>(
    base?: I,
  ): Product_ProductImage_AnchorProduct_InventoryEntry {
    return Product_ProductImage_AnchorProduct_InventoryEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ProductImage_AnchorProduct_InventoryEntry>, I>>(
    object: I,
  ): Product_ProductImage_AnchorProduct_InventoryEntry {
    const message = createBaseProduct_ProductImage_AnchorProduct_InventoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Product_Inventory.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseProduct_Inventory(): Product_Inventory {
  return { num: 0, stockRemind: false };
}

export const Product_Inventory = {
  fromJSON(object: any): Product_Inventory {
    return {
      num: isSet(object.num) ? Number(object.num) : 0,
      stockRemind: isSet(object.stockRemind) ? Boolean(object.stockRemind) : false,
    };
  },

  toJSON(message: Product_Inventory): unknown {
    const obj: any = {};
    message.num !== undefined && (obj.num = Math.round(message.num));
    message.stockRemind !== undefined && (obj.stockRemind = message.stockRemind);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_Inventory>, I>>(base?: I): Product_Inventory {
    return Product_Inventory.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_Inventory>, I>>(object: I): Product_Inventory {
    const message = createBaseProduct_Inventory();
    message.num = object.num ?? 0;
    message.stockRemind = object.stockRemind ?? false;
    return message;
  },
};

function createBaseProduct_ShippingFee(): Product_ShippingFee {
  return { paymentTitle: "", promotionTitle: "", deliveryTitle: "", deliveryContent: "", feeInfos: [] };
}

export const Product_ShippingFee = {
  fromJSON(object: any): Product_ShippingFee {
    return {
      paymentTitle: isSet(object.paymentTitle) ? String(object.paymentTitle) : "",
      promotionTitle: isSet(object.promotionTitle) ? String(object.promotionTitle) : "",
      deliveryTitle: isSet(object.deliveryTitle) ? String(object.deliveryTitle) : "",
      deliveryContent: isSet(object.deliveryContent) ? String(object.deliveryContent) : "",
      feeInfos: Array.isArray(object?.feeInfos)
        ? object.feeInfos.map((e: any) => Product_ShippingFee_FeeInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Product_ShippingFee): unknown {
    const obj: any = {};
    message.paymentTitle !== undefined && (obj.paymentTitle = message.paymentTitle);
    message.promotionTitle !== undefined && (obj.promotionTitle = message.promotionTitle);
    message.deliveryTitle !== undefined && (obj.deliveryTitle = message.deliveryTitle);
    message.deliveryContent !== undefined && (obj.deliveryContent = message.deliveryContent);
    if (message.feeInfos) {
      obj.feeInfos = message.feeInfos.map((e) => e ? Product_ShippingFee_FeeInfo.toJSON(e) : undefined);
    } else {
      obj.feeInfos = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ShippingFee>, I>>(base?: I): Product_ShippingFee {
    return Product_ShippingFee.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ShippingFee>, I>>(object: I): Product_ShippingFee {
    const message = createBaseProduct_ShippingFee();
    message.paymentTitle = object.paymentTitle ?? "";
    message.promotionTitle = object.promotionTitle ?? "";
    message.deliveryTitle = object.deliveryTitle ?? "";
    message.deliveryContent = object.deliveryContent ?? "";
    message.feeInfos = object.feeInfos?.map((e) => Product_ShippingFee_FeeInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProduct_ShippingFee_FeeInfo(): Product_ShippingFee_FeeInfo {
  return { desc: undefined, image: undefined, subTitle: "", fee: "" };
}

export const Product_ShippingFee_FeeInfo = {
  fromJSON(object: any): Product_ShippingFee_FeeInfo {
    return {
      desc: isSet(object.desc) ? String(object.desc) : undefined,
      image: isSet(object.image) ? Image.fromJSON(object.image) : undefined,
      subTitle: isSet(object.subTitle) ? String(object.subTitle) : "",
      fee: isSet(object.fee) ? String(object.fee) : "",
    };
  },

  toJSON(message: Product_ShippingFee_FeeInfo): unknown {
    const obj: any = {};
    message.desc !== undefined && (obj.desc = message.desc);
    message.image !== undefined && (obj.image = message.image ? Image.toJSON(message.image) : undefined);
    message.subTitle !== undefined && (obj.subTitle = message.subTitle);
    message.fee !== undefined && (obj.fee = message.fee);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_ShippingFee_FeeInfo>, I>>(base?: I): Product_ShippingFee_FeeInfo {
    return Product_ShippingFee_FeeInfo.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_ShippingFee_FeeInfo>, I>>(object: I): Product_ShippingFee_FeeInfo {
    const message = createBaseProduct_ShippingFee_FeeInfo();
    message.desc = object.desc ?? undefined;
    message.image = (object.image !== undefined && object.image !== null) ? Image.fromPartial(object.image) : undefined;
    message.subTitle = object.subTitle ?? "";
    message.fee = object.fee ?? "";
    return message;
  },
};

function createBaseProduct_InventoryEntry(): Product_InventoryEntry {
  return { key: "", value: undefined };
}

export const Product_InventoryEntry = {
  fromJSON(object: any): Product_InventoryEntry {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? Product_Inventory.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: Product_InventoryEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value ? Product_Inventory.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<Product_InventoryEntry>, I>>(base?: I): Product_InventoryEntry {
    return Product_InventoryEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Product_InventoryEntry>, I>>(object: I): Product_InventoryEntry {
    const message = createBaseProduct_InventoryEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? Product_Inventory.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseOutfitStyle(): OutfitStyle {
  return { id: "", title: "", cover: undefined, items: [], itemAspectRatio: 0 };
}

export const OutfitStyle = {
  fromJSON(object: any): OutfitStyle {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      title: isSet(object.title) ? String(object.title) : "",
      cover: isSet(object.cover) ? Image.fromJSON(object.cover) : undefined,
      items: Array.isArray(object?.items)
        ? object.items.map((e: any) => OutfitStyle_Item.fromJSON(e))
        : [],
      itemAspectRatio: isSet(object.itemAspectRatio) ? Number(object.itemAspectRatio) : 0,
    };
  },

  toJSON(message: OutfitStyle): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.title !== undefined && (obj.title = message.title);
    message.cover !== undefined && (obj.cover = message.cover ? Image.toJSON(message.cover) : undefined);
    if (message.items) {
      obj.items = message.items.map((e) => e ? OutfitStyle_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    message.itemAspectRatio !== undefined && (obj.itemAspectRatio = message.itemAspectRatio);
    return obj;
  },

  create<I extends Exact<DeepPartial<OutfitStyle>, I>>(base?: I): OutfitStyle {
    return OutfitStyle.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<OutfitStyle>, I>>(object: I): OutfitStyle {
    const message = createBaseOutfitStyle();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.cover = (object.cover !== undefined && object.cover !== null) ? Image.fromPartial(object.cover) : undefined;
    message.items = object.items?.map((e) => OutfitStyle_Item.fromPartial(e)) || [];
    message.itemAspectRatio = object.itemAspectRatio ?? 0;
    return message;
  },
};

function createBaseOutfitStyle_Item(): OutfitStyle_Item {
  return { imageHash: "", anchorProducts: [] };
}

export const OutfitStyle_Item = {
  fromJSON(object: any): OutfitStyle_Item {
    return {
      imageHash: isSet(object.imageHash) ? String(object.imageHash) : "",
      anchorProducts: Array.isArray(object?.anchorProducts)
        ? object.anchorProducts.map((e: any) => OutfitStyle_Item_AnchorProduct.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OutfitStyle_Item): unknown {
    const obj: any = {};
    message.imageHash !== undefined && (obj.imageHash = message.imageHash);
    if (message.anchorProducts) {
      obj.anchorProducts = message.anchorProducts.map((e) => e ? OutfitStyle_Item_AnchorProduct.toJSON(e) : undefined);
    } else {
      obj.anchorProducts = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OutfitStyle_Item>, I>>(base?: I): OutfitStyle_Item {
    return OutfitStyle_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<OutfitStyle_Item>, I>>(object: I): OutfitStyle_Item {
    const message = createBaseOutfitStyle_Item();
    message.imageHash = object.imageHash ?? "";
    message.anchorProducts = object.anchorProducts?.map((e) => OutfitStyle_Item_AnchorProduct.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOutfitStyle_Item_AnchorProduct(): OutfitStyle_Item_AnchorProduct {
  return { productId: "", anchor: undefined, saleState: 0, tagName: "" };
}

export const OutfitStyle_Item_AnchorProduct = {
  fromJSON(object: any): OutfitStyle_Item_AnchorProduct {
    return {
      productId: isSet(object.productId) ? String(object.productId) : "",
      anchor: isSet(object.anchor) ? Anchor.fromJSON(object.anchor) : undefined,
      saleState: isSet(object.saleState) ? productSaleStateFromJSON(object.saleState) : 0,
      tagName: isSet(object.tagName) ? String(object.tagName) : "",
    };
  },

  toJSON(message: OutfitStyle_Item_AnchorProduct): unknown {
    const obj: any = {};
    message.productId !== undefined && (obj.productId = message.productId);
    message.anchor !== undefined && (obj.anchor = message.anchor ? Anchor.toJSON(message.anchor) : undefined);
    message.saleState !== undefined && (obj.saleState = productSaleStateToJSON(message.saleState));
    message.tagName !== undefined && (obj.tagName = message.tagName);
    return obj;
  },

  create<I extends Exact<DeepPartial<OutfitStyle_Item_AnchorProduct>, I>>(base?: I): OutfitStyle_Item_AnchorProduct {
    return OutfitStyle_Item_AnchorProduct.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<OutfitStyle_Item_AnchorProduct>, I>>(
    object: I,
  ): OutfitStyle_Item_AnchorProduct {
    const message = createBaseOutfitStyle_Item_AnchorProduct();
    message.productId = object.productId ?? "";
    message.anchor = (object.anchor !== undefined && object.anchor !== null)
      ? Anchor.fromPartial(object.anchor)
      : undefined;
    message.saleState = object.saleState ?? 0;
    message.tagName = object.tagName ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
